import React from "react";
import { Skeleton } from "components";

export default function NewsSkeleton() {
  return <Skeleton count={1} height={55} width={"100%"} />;
}
